let initialState = {
  open: false,
  id: undefined
};

export default function(state = initialState, action){

  switch(action.type){

    case "@@router/LOCATION_CHANGE":
      return {
        ...state,
        open: false,
        id: undefined
      };

    case "menu/ACTIVATE_MENU":
      return {
        ...state,
        open: true,
        id: action.payload
      };

    case "menu/DEACTIVATE_MENU":
      return {
        ...state,
        open: false,
        id: undefined
      };


    default: return state;
  }

}


// WEBPACK FOOTER //
// ./src/reducers/menu.js